import { appRoutePath, type ActiveView } from "./routes.js";

export type PortfolioRequiredDestination =
  "workspace" | "add_holdings" | "new_scenario" | "evidence" | "decision_packs";

export function parsePortfolioRequiredDestination(
  value: unknown,
): PortfolioRequiredDestination | undefined {
  return value === "workspace" ||
    value === "add_holdings" ||
    value === "new_scenario" ||
    value === "evidence" ||
    value === "decision_packs"
    ? value
    : undefined;
}

export function pathAfterPortfolioCreation(
  bookId: string,
  destination?: PortfolioRequiredDestination,
): string {
  return appRoutePath(destination ?? "workspace", bookId);
}

export function isPortfolioRequiredDestination(
  view: ActiveView,
): view is PortfolioRequiredDestination {
  return (
    view === "workspace" ||
    view === "add_holdings" ||
    view === "new_scenario" ||
    view === "evidence" ||
    view === "decision_packs"
  );
}
